var React = require('react');

function PaymentsIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#131416","fillRule":"evenodd","d":"M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11Zm0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-16a1 1 0 0 0-1 1v1.13c-1.399.307-2.483 1.167-2.483 2.717-.011 2.024 1.728 2.527 3.224 2.96 1.127.325 2.115.61 2.115 1.476 0 .74-.727 1.053-1.665 1.053-1.11 0-2.526-.462-3.406-1.22L8 15.633c.768.672 1.865 1.11 3 1.284V18a1 1 0 1 0 2 0v-1.062c1.66-.235 3-1.146 3-2.858.011-2.084-1.832-2.617-3.367-3.06-1.093-.316-2.03-.586-2.03-1.34 0-.702.631-.98 1.493-.98.9 0 2.028.333 2.928.87l.804-1.572c-.745-.51-1.78-.849-2.828-.96V6a1 1 0 0 0-1-1Z","clipRule":"evenodd"}));
}

PaymentsIconInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = PaymentsIconInline;

PaymentsIconInline.default = PaymentsIconInline;
